module.exports = __webpack_public_path__ + "42c1734799d167fb27d3913eaada7ffb.jpg";